import MessageWindow from '@c/dashboard/MessageWindow';
import BaseModal from './BaseModal';
import { MessageWindowProps } from '@c/dashboard/MessageWindow';
interface MobileChatModalProps {
  isOpen: boolean;
}
function MobileChatModal({
  isOpen,
  goBack,
  chat,
  previewSlot,
}: MobileChatModalProps & MessageWindowProps) {
  return (
    <BaseModal isOpen={isOpen} hideCloseIcon isFullScreen>
      <MessageWindow goBack={goBack} chat={chat} previewSlot={previewSlot} />
    </BaseModal>
  );
}

export default MobileChatModal;
